import React from "react";
import { Box, Card, CardContent, Divider, Stack, Typography, useTheme } from "@mui/material";

export default function SectionCard({ title, subtitle, actions, children, padding = 3, sx, accent }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  // Tighten section padding on phones to cut vertical scroll; keep the caller's
  // value on tablet/desktop. Only reduce when there's room (padding > 2).
  const padX = { xs: padding > 2 ? 2 : padding, sm: padding };
  return (
    <Card
      elevation={0}
      sx={{
        bgcolor: isDark ? "#121212" : "#F7F7F8",
        border: isDark ? "1px solid #262626" : "1px solid #eeeeee",
        borderRadius: 4,
        ...(accent ? { borderBottom: `5px solid ${accent}` } : {}),
        transition: "all 0.2s ease",
        "&:hover": { boxShadow: isDark ? "0 4px 16px rgba(0,0,0,0.4)" : "0 4px 16px rgba(0,0,0,0.06)" },
        ...sx,
      }}
    >
      {(title || actions) && (
        <>
          <Box sx={{ px: padX, py: { xs: 1.75, sm: 2.25 } }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
              <Box sx={{ minWidth: 0 }}>
                {title && (
                  <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 15, lineHeight: 1.3 }}>
                    {title}
                  </Typography>
                )}
                {subtitle && (
                  <Typography variant="caption" sx={{ color: "text.secondary", fontSize: 12, display: "block", mt: 0.25 }}>
                    {subtitle}
                  </Typography>
                )}
              </Box>
              {actions && <Stack direction="row" spacing={1} flexShrink={0}>{actions}</Stack>}
            </Stack>
          </Box>
          <Divider />
        </>
      )}
      <CardContent sx={{ p: padX, "&:last-child": { pb: padX } }}>{children}</CardContent>
    </Card>
  );
}
